module.exports = "assets/img/Tour_cybernetique.jpg";